
export const account = {
  namespaced: true,
  state: {
    iban:'',
    id:'',
    description:'',
    token: null,
  },
  getters: {
    IS_AUTHENTICATED(state) {
      return state.token == null ? false : true;
    },
  },
  mutations: {

    id(state, payload) {
      state.id = payload;
    },
    token(state, payload) {
      state.token = payload;
    },

    changeDescription(state, payload) {
      state.description =  payload
    },

    changeIban(state, payload) {
      state.iban =  payload
    },

  },

}